import Select from "@/components/Select";
import { useTranslation } from "@/i18n/client";
import { useContext } from "react";
import { EnumerationsContext } from "@/contexts/EnumerationsContext";
import { getMappedEnumToSelect } from "@/screens/common/Degree/helpers";
import { SelectProps } from "@mantine/core";

export const DegreeAfterName = (props: SelectProps) => {
  const enums = useContext(EnumerationsContext);
  const { t } = useTranslation("customer");

  const empty = [{ value: "", label: "Bez titulu" }];
  return (
    <Select
      searchable
      label={t("degreeAfter")}
      data={empty.concat(getMappedEnumToSelect(enums.degreeAfters))}
      allowDeselect
      pii
      {...props}
    />
  );
};
